export default {
    content_plural: "Contenu",
    content: "Contenu",
    finished: "Fini",
    how_do_you_rate_this_trail: "Comment évaluez-vous cette piste?",
    loading_trails: "Chargement des pistes",
    no_trails_are_available_at_the_moment: "Il n'y a actuellement aucun piste disponible",
    no_trails_are_available_with_the_selected_filter: "Aucune piste n'est disponible pour le filtre sélectionné",
    only_available_when_finished_trail: "Disponible uniquement une fois le parcours terminé"
}